import './button-friend-plus.scss'

import { Skeleton } from '@acctglobal/skeleton'
import { Link } from 'gatsby'
import React from 'react'

import logoPlusFriend from '../../../../../assets/logoPlusFriend.png'
import { useClubContext } from '../../../../../contexts/ClubContext'
import { useStoreContext } from '../../../../../contexts/StoreContext'
import useWindowDimensions from '../../../../../hooks/useWindowDimensions'

const ButtonFriendPlus = () => {
  const { userInfos: clubUserInfos, isLoading } = useClubContext()
  const { hasClubPlusInDropdown } = useStoreContext()
  const { isMobile } = useWindowDimensions()

  if (!hasClubPlusInDropdown) {
    return null
  }

  if (isLoading) {
    return (
      <div className="buttonFriendPlus-header">
        <Skeleton
          width={isMobile ? 68 : 90}
          height={isMobile ? 24 : 32}
          margin={0}
          backgroundColor="var(--color-grayScale-faded)"
        />
      </div>
    )
  }

  return (
    <div className="buttonFriendPlus-header">
      <Link
        to={`${clubUserInfos?.isCartonist ? '/cartao/cartonista' : '/clube'}`}
        className="buttonFriendPlus-header-link"
      >
        <img src={logoPlusFriend} alt="Logo +amigo" className="logo" />
      </Link>
    </div>
  )
}

export default ButtonFriendPlus
